<ngx-smart-modal #InitiateRequeueLibraryModal 
    [identifier]="modalType" 
    [title]="ngxSmartModalTitle" 
    closable="true"
    showCloseButton="true" 
    [closeButtonText]="closeButtonText" 
    [disableConfirmButton]="disableConfirmButton"
    [confirmButtonText]="confirmButtonText">
    <app-lab-requeue 
        [informationListToDisplay]="infoList" 
        [selectedLabWorkflow]="selectedLabWorkflow"
        [errorMsg]="errorMsg" 
        (confirm)="dataChanged($event)"
    ></app-lab-requeue>

</ngx-smart-modal>